import {
  ChangeDetectionStrategy,
  Component,
  OnDestroy,
  OnInit,
} from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { ConnectionStatus } from '@epicuro-next/models/users';
import { setUserConnectionStatus } from '@epicuro-next/state/connect-state';
import { Store } from '@ngrx/store';
import { Subject } from 'rxjs';
import { map, takeUntil } from 'rxjs/operators';

@Component({
  selector: 'epc-connect-availability',
  templateUrl: './connect-availability.component.html',
  styleUrls: ['./connect-availability.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class ConnectAvailabilityComponent implements OnInit, OnDestroy {
  public availability = new UntypedFormControl(true);
  private destroy$ = new Subject<void>();

  constructor(private store: Store) {}

  public ngOnInit(): void {
    this.onAvailablityChange();
  }

  public onAvailablityChange() {
    this.availability.valueChanges
      .pipe(
        map((value) =>
          value ? ConnectionStatus.AVAILABLE : ConnectionStatus.NOTAVAILABLE,
        ),
        takeUntil(this.destroy$),
      )
      .subscribe((status) => {
        this.store.dispatch(setUserConnectionStatus({ status }));
      });
  }

  public ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
